/**
 * T071: Storage Redux Reducer
 * Manages storage providers and policies state
 */

import * as Actions from '../actions';

const initialState = {
	// Storage Providers
	providers: [],
	selectedProvider: null,
	providerLoading: false,
	providerError: null,
	
	// Storage Policies
	policies: [],
	predefinedPolicies: [],
	selectedPolicy: null,
	policyLoading: false,
	policyError: null,
	
	// UI State
	providerFormOpen: false,
	policyFormOpen: false
};

const storageReducer = (state = initialState, action) => {
	switch (action.type) {
		// Storage Providers
		case Actions.STORAGE_PROVIDERS_LOADING: {
			return {
				...state,
				providerLoading: true,
				providerError: null
			};
		}
		case Actions.STORAGE_PROVIDERS_SUCCESS: {
			return {
				...state,
				providers: action.payload,
				providerLoading: false,
				providerError: null
			};
		}
		case Actions.STORAGE_PROVIDERS_ERROR: {
			return {
				...state,
				providerLoading: false,
				providerError: action.payload
			};
		}
		case Actions.STORAGE_PROVIDER_SELECT: {
			return {
				...state,
				selectedProvider: action.payload
			};
		}
		case Actions.STORAGE_PROVIDER_CREATE_SUCCESS: {
			return {
				...state,
				providers: [...state.providers, action.payload],
				providerFormOpen: false,
				selectedProvider: action.payload
			};
		}
		case Actions.STORAGE_PROVIDER_UPDATE_SUCCESS: {
			return {
				...state,
				providers: state.providers.map(p =>
					p._id === action.payload._id ? action.payload : p
				),
				selectedProvider: action.payload
			};
		}
		case Actions.STORAGE_PROVIDER_DELETE_SUCCESS: {
			return {
				...state,
				providers: state.providers.filter(p => p._id !== action.payload),
				selectedProvider: state.selectedProvider?._id === action.payload ? null : state.selectedProvider
			};
		}
		
		// Storage Policies
		case Actions.STORAGE_POLICIES_LOADING: {
			return {
				...state,
				policyLoading: true,
				policyError: null
			};
		}
		case Actions.STORAGE_POLICIES_SUCCESS: {
			return {
				...state,
				policies: action.payload,
				policyLoading: false,
				policyError: null
			};
		}
		case Actions.STORAGE_POLICIES_ERROR: {
			return {
				...state,
				policyLoading: false,
				policyError: action.payload
			};
		}
		case Actions.STORAGE_PREDEFINED_POLICIES_SUCCESS: {
			return {
				...state,
				predefinedPolicies: action.payload
			};
		}
		case Actions.STORAGE_POLICY_SELECT: {
			return {
				...state,
				selectedPolicy: action.payload
			};
		}
		case Actions.STORAGE_POLICY_CREATE_SUCCESS: {
			return {
				...state,
				policies: [...state.policies, action.payload],
				policyFormOpen: false,
				selectedPolicy: action.payload
			};
		}
		case Actions.STORAGE_POLICY_UPDATE_SUCCESS: {
			return {
				...state,
				policies: state.policies.map(p =>
					p._id === action.payload._id ? action.payload : p
				),
				selectedPolicy: action.payload
			};
		}
		case Actions.STORAGE_POLICY_DELETE_SUCCESS: {
			return {
				...state,
				policies: state.policies.filter(p => p._id !== action.payload),
				selectedPolicy: state.selectedPolicy?._id === action.payload ? null : state.selectedPolicy
			};
		}
		
		// UI State
		case Actions.STORAGE_PROVIDER_FORM_OPEN: {
			return {
				...state,
				providerFormOpen: true
			};
		}
		case Actions.STORAGE_PROVIDER_FORM_CLOSE: {
			return {
				...state,
				providerFormOpen: false,
				selectedProvider: null
			};
		}
		case Actions.STORAGE_POLICY_FORM_OPEN: {
			return {
				...state,
				policyFormOpen: true
			};
		}
		case Actions.STORAGE_POLICY_FORM_CLOSE: {
			return {
				...state,
				policyFormOpen: false,
				selectedPolicy: null
			};
		}
		
		// Clear State
		case Actions.STORAGE_CLEAR: {
			return initialState;
		}
		
		default: {
			return state;
		}
	}
};

export default storageReducer;
